import React from "react";

const Page = ({ navbar, children }) => {
  return (
    <body>
      {navbar}
      <main>
        <div className="position-relative">{children}</div>
      </main>
    </body>
  );
};

export default Page;
